
// Insert any custom theme js here...
/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function() {
  // Écoute de l'événement de soumission du formulaire
  $("#form-master-mind").submit(function(event) {
    // Empêcher le comportement par défaut du formulaire
    event.preventDefault();

    let order = {
      "_details": [
        {
          "quantity": 1,
          "product_name": "Accès MASTERMIND ECOMTUN",
          "product_id": $("#form-master-mind #product_id").val(),
          "taxe_rate": 0,
          "category_id": null,
          "product_parent_id": $("#form-master-mind #product_id").val(),
          "active_stock": false,
          "product_ref": "",
          "price_ttc_after_discount": 150
        }
      ],
        "address":"",
    "code_postal":"",
    "comment":"",
    "contact":"",
    "country":"TN",
    "delegation":"",
    "payement_type":"ONLINE",
    "total_amount":150,
    "name": $("#form-master-mind #nom").val(),
    "phone":$("#form-master-mind #telephone").val(),
    "email":$("#form-master-mind #email").val()
    };

    let data = {
      order: order,
      company: "BLoD6j0",
      create_account: false
    };

    $(".loading-back").fadeIn();

    // Envoyer les données en AJAX
    $.ajax({
      url: "https://api.tiktak.space/api/v1/create-fast-order/",
      type: "POST",
      data: JSON.stringify(data),
      contentType: "application/json",
      success: function(response) {
        if (response['payment']) {
          //if payment online redirection only and dont delete anything
          window.location.href = response.payment.payUrl;
        }
      },
      error: function(xhr, status, error) {
        $(".loading-back").hide();
        console.log("Erreur AJAX : " + error);
        alert("Il y a une erreur");
      }
    });
  });
});
